import { Navbar } from "@/components/landing/Navbar";
import { Services as ServicesSection } from "@/components/landing/Services";
import { Industries } from "@/components/landing/Industries";
import { Footer } from "@/components/landing/Footer";
import { ScrollProgress, WhatsAppFab } from "@/components/landing/Floating";
import SEO from "@/components/SEO";

export default function ServicesPage() {
  return (
    <div className="relative min-h-screen bg-white font-sans text-navy-900 antialiased" data-testid="services-page">
      <SEO
        title="Business Compliance & Registration Services Directory | Biz360 Compliance"
        description="Browse all 66+ expert-led compliance services: Company registration, GST, Income Tax, ROC annual filings, Accounting, Payroll and Business Licences in India."
        canonical="/services"
        keywords="business compliance services India, company incorporation, GST filing Pune, ROC annual compliance, accounting services"
        breadcrumbs={[{ label: "Services", href: "/services" }]}
      />
      <ScrollProgress />
      <Navbar />
      <main className="pt-20 md:pt-24">
        <ServicesSection />
        <Industries />
      </main>
      <Footer />
      <WhatsAppFab />
    </div>
  );
}
